<div right class="aside-right">

  <div *ngIf="isMobile" class="mobile-header-aside">
    <h3 class="m-0 font-weight-bold" style="font-size: 18px; color: #333;">
      {{ 'envelope.main-envelope.asideLeft.custom-Fields.positioning.title' | translate }}
    </h3>
    <button class="cdx-button cdx-button--icon cdx-button--lg border-less m-0" (click)="asideRight()">
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far', 'bars']" size="sm"></fa-icon>
    </button>
  </div>

  <div *ngIf="!isMobile" class="page-miniatures" #thumbnailContainer>
    <button
      *ngFor="let fileConfig of pagesEnvelopeFileSelected(); let i = index"
      type="button"
      [attr.data-page]="fileConfig.page"
      (click)="selectedPage(fileConfig)"
      [ngClass]="{'page-active': fileConfig.selected === true}"
      [style.border-color]="fileConfig.selected ? themePrimaryColor : 'transparent'"
      class="miniature flex-custom">
      <div class="pill">
        <cdx-pill [options]="pill" *ngIf="insertPill(fileConfig.page)"></cdx-pill>
      </div>
      <cdx-badge type="default" value="{{ i + 1 }}" class="m-2"></cdx-badge>
    </button>
  </div>

  <div class="container-files">

    <div *ngIf="isMobile" class="mobile-layout">
      <div *ngIf="interactService.withRubrics" class="mobile-section mb-3">
        <h5 class="font-weight-bold" style="font-size: 16px; color: #333; margin-bottom: 5px;">{{ 'envelope.main-envelope.asideLeft.custom-Fields.positioning.automaticLoading' | translate }}</h5>
        <p class="text-muted small mb-2" style="font-size: 13px; line-height: 1.4;">
          {{ 'envelope.main-envelope.asideLeft.custom-Fields.positioning.mobileAutomaticDescription' | translate }}
        </p>

        <div class="d-flex align-items-center">
          <cdx-toggle-switch
            [toggledOn]="newEnvelopeService.includeRubrics"
            (toggle)="onChangeIncludeRubric($event)"
            (click)="handleToggleClickRubric($event)">
          </cdx-toggle-switch>
          <span style="font-weight: 500; color: #333; margin-left: 10px;">
            {{ 'envelope.main-envelope.asideRight.loadRubrics' | translate }}
          </span>
        </div>
      </div>
    </div>

    <div class="body body-table mb-4">
      <table class="table table-hover table-responsive-lg" style="table-layout: fixed; width: 100%;">
        <colgroup *ngIf="!isMobile">
          <col width="40"/>
          <col width="126"/>
          <col width="126"/>
        </colgroup>

        <colgroup *ngIf="isMobile">
          <col/>
          <col style="width: 60%;"/>
          <col style="width: 30%;"/>
        </colgroup>
        
        <thead>
          <tr>
            <th colspan="2"><span class="gray">{{ "documents" | translate | titlecase }}</span></th>
            <th colspan="1"><span class="gray">{{ "stampsOfSignatures" | translate }}</span></th>
          </tr>
        </thead>
        <tbody *ngFor="let file of this.newEnvelopeService.envelopeFiles">
          <tr [ngClass]="{'row-active': file.checked === true}" (click)="itemRadioSelected(file)">
            <td class="table__cell-icon">
              <fa-icon class="fa-lg" [icon]="['far',((file.checked===true) ? 'dot-circle': 'circle')]"></fa-icon>
            </td>
            <td class="text-left">
              <span class="d-inline-block text-truncate w-100" style="vertical-align: middle;" ngbTooltip="{{file.name}}">{{file.name}}</span>
            </td>
            <td class="w-100">
              <cdx-tag [ngStyle]="{'max-width': none}"[options]="checkStatusStampsOfSignaturesByFileName(file.name) ? completedTag : warningTag"></cdx-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
